import React from 'react';
import PageBody from '../../components/pagebody/PageBody';
import { Route, Routes, Navigate } from 'react-router-dom';
import ChangePassword from './changepassword/ChangePassword';
import EditProfile from './editprofile/EditProfile';
import TwoFactorAuthentication from './twofactorauthentication/TwoFactorAuthentication';
import ActivityLogs from './activitylogs/ActivityLogs';
import General from './general/General';

export default function AccountSection() {
    return (
        <PageBody>
            <Routes>
                <Route path="/changepassword" element={<ChangePassword />} />
                <Route path="/editprofile" element={<EditProfile />} />
                <Route path="/twofactorauthentication" element={<TwoFactorAuthentication />} />
                <Route path="/activitylogs" element={<ActivityLogs />} />
                <Route path="/general" element={<General />} />
                <Route path={'/*'} element={<Navigate to={`/`} replace={true} />} />
            </Routes>
        </PageBody>
    )
}